import { updateObject } from 'utils/updateObject'
import { v4 as uuidv4 } from 'uuid'

const initialState = {
  modals: [],
}

const showModal = (state, { payload }) =>
  updateObject(state, {
    modals: [
      ...state.modals,
      {
        modalProps: {
          ...payload.modalProps,
          ...payload,
        },
        UUID: payload.UUID || uuidv4(),
        modalType: payload.modalType,
        openFrom: !!payload?.openFrom,
      },
    ],
  })

const updateModalByUUID = (state, { payload }) =>
  updateObject(state, {
    modals: state.modals.map((modal) =>
      modal.UUID === payload.UUID
        ? {
            ...modal,
            modalProps: { ...modal.modalProps, ...payload.modalProps },
          }
        : modal,
    ),
  })

const hideModal = (state, { payload }) => {
  if (payload) {
    const payloadKeys = Object.keys(payload)

    return updateObject(state, {
      modals: state.modals.map((modal) => {
        const equalValueKeys = payloadKeys.filter((key) => modal[key] === payload[key])

        if (payloadKeys.length === equalValueKeys.length) {
          return { ...modal, closeRequest: true }
        }

        return modal
      }),
    })
  }

  return updateObject(state, {
    modals: state.modals.map((modal) => ({ ...modal, closeRequest: true })),
  })
}

const removeModal = (state, { payload }) => {
  if (payload && payload.UUID) {
    return updateObject(state, {
      modals: state.modals.filter((modal) => modal.UUID !== payload.UUID),
    })
  }

  return initialState
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'MODAL/SHOW':
      return showModal(state, action)
    case 'MODAL/HIDE':
      return hideModal(state, action)
    case 'MODAL/UPDATE_MODAL_BY_UUID':
      return updateModalByUUID(state, action)
    case 'MODAL/REMOVE':
      return removeModal(state, action)
    default:
      return state
  }
}
